import namesLibrary from './libraries/names'
import randomInt from 'random-int'

/**
 * Get a random name
 * @return string
 */
const name = () => {
  let number = randomInt( 0, namesLibrary.length - 1 )

  return namesLibrary[ number ]
}

export default name



// WEBPACK FOOTER //
// ./src/name.js